<div class="requests-container">
  <div class="container-fluid">
    <div class="row g-6 mb-6"></div>
    <div class="table-container">
      <div class="home-parking-request-title">
        <h5>Cerere de parcare la domiciliu</h5>
      </div>
      <div class="table-responsive">
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table table-hover table-nowrap"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" (click)="sortTable('firstName')">Nume</th>
              <th scope="col" (click)="sortTable('lastName')">Prenume</th>
              <th scope="col" (click)="sortTable('subscriptionZoneName')">
                Abonament
              </th>
              <th scope="col" (click)="sortTable('email')">Adresa de e-mail</th>
              <th scope="col" (click)="sortTable('createdAt')">Data și ora</th>
              <th scope="col" (click)="sortTable('status')">Status</th>
              <th></th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>
